<template>
  <div
    style="width: 100%; padding-bottom: 4.33333rem; background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;"
  >
    <div class="header">
      <div class="header_content">
        <div v-if="!hasToken" @click="toLogin('/Register')">
          {{$t("auth.register")}}
        </div>
        <div v-else>
          <div style="padding: 10px 0px 0px 0px;">
            <img style="height:28px" src="/img/home/xx.png" @click="toLogin('/Notice')" />
          </div>
        </div>
        <div class="img" style="width: 60px;height: 60px;">
          <img src="/img/home/logo11.png" alt="" style="width: 60px;height: 60px;" />
        </div>
        <div
          style="display: flex; align-items: center;"
          v-if="!hasToken"
          @click="toLogin('/Login')"
        >
          <van-icon name="chat-o" color="#fff" size="24" />
          {{$t("auth.login")}}
        </div>
        <div style="padding: 10px 0px 0px 0px;" v-else @click="toLogin('/Mine')">
          <img src="/img/home/gr.png" style="height:28px" />
        </div>
      </div>
    </div>
    <div style="height: 160px;">
      <div style="padding: 8px;">
        <van-notice-bar
          class="notice-swiper"
          color="#000"
          background="#fff"
          scrollable
          :text="this.notice"
        >
          <template #left-icon>
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAYAAACQ0cTtAAAAAXNSR0IArs4c6QAAAzpJREFUSEutlkFoHGUUx///2Z3daAOa6s5HZqa1rcFeSm0IaTqfJeZgixQxt6qH5qQgUjCBioKHepAWrGArpoIK0ktAEdpDoEQsFEt32yhSqwdPtpjZhtn14DFks/NkZpu4MbPZCczchu+9/2++9/3f+4bY4qPU/m2S750gw18C/9btraRzK8El1xugcJbEXgH+qeUL/bh/fSmtRmqY5WiPxCyA7avioWCwXi3fyRSmXP2GANMEzHbhkBytL9y8kRnMcr1zBE8lCYZNjtYXM4D19Q09VthWnAFwrNOXJ8H67KGdBRY+BlAOqpXz7bmJZ6bUwd2Sz1+NjLBZiZJglqOnSbwV5QnwXc0vvAZcX4neN8BK9shhg7nLIJ7sdhaJMFsfpYErAB6J80W+DaqVVzbAYiMILpLIdwNF653OrGR7gwY5B6L0cIfv1vzyR7QcfZGUFyEgyF1pIGvW32iQHIBmtG65I/uJ3DyAIiDLTRq7qVwtWwGss34bbLs9vMOkeRPE3cAvvxQDbe8UDZ6LqyByITOYZY8coZH7PhamnKwvVKaBIVM5RR+EJcBiZrB4J46+QeIwBH8H1UJ/5ELl6i8BvB4bJKsytsoWO3GuZYrmszX/9l3LOfQmaXyeOezxfv1UMYf7MSyU52oPKuWSc+i4QeObzGGW402QvBSbqNF4Ogh++lO53tsA40mSWRlLpbFeFpf/IOAA+Dnwy8OtFtBXCIxnClO2HkdrcgBheCR4cOsHpbQFE39FvSbAr1FTN9JOjP/3Y/sEse2hR5ssfgbiTuCXP22507tEcqKVJ5NUSu+DCU8ES4BMkRxM2+SbXTHtLhSIXwOeWT+Id431WI3lL0icSAPsOBtd7z0DPLumIfJCUK1cS75iHP0+iA+7AZNgyvEmQX7yX65MBn7lQmyQToLK1q/CwNcAejrFJF4xrv6AwGkBGoS8swraFBYtPrFDD+dDzEazLQnYoYw5ZXvHYeD3wK/81p7X9e9KqeE9YppzBAY2c2O3knfd2apA1C9iIgIeaBcNiefrC+Uf04BSw6LA6E8Y+d4ZEC+viTdW9gTB/L3MYQ8FqWzvDMiTIeSrerUylRYUxf0L2HxhjnpTPGYAAAAASUVORK5CYII="
              alt="Custom Icon"
              style="width: 15px; height: 15px; margin-right: 10px;"
            />
          </template>
        </van-notice-bar>
      </div>
      <swiper class="banner_swiper" :options="bannerSwiperOption" style="background: unset;height: 160px;">
        <swiper-slide v-for="(v,key) in banners" :key="key" style="border-radius: 15px;">
          <van-image class="banner_img" :src="`${v.url}`" width="100%" height="160px">
            <template v-slot:loading style="border-radius: 15px;">
              <van-loading type="circular" style="border-radius: 15px;" />
            </template>
          </van-image>
        </swiper-slide>
      </swiper>
    </div>
    <div style="width: 100%;height: 58px;"></div>
    <div
      style="width: 94%; background: repeating-linear-gradient(-60deg, #f85c9a, #f64a8e, #f85c9a, #f64a8e, #f85c9a, #f64a8e, #f85c9a, #f64a8e); margin: 8px auto; border-radius: 8px; padding: 8px; color: #fff; box-shadow: 0 0 .2px rgba(253, 16, 107, .51);"
    >
      <div style="display: flex;justify-content: flex-start;align-items: center;">
        <div style="border-right: 1px solid #fff;width: 40%;">
          <img src="/img/logo.png" style="height:108px" />
        </div>
        <div
          style="width: 60%; padding-left: 10px; line-height: 18px; font-size: 12px; text-align: left;color:#fff"
        >
          {{$t("foorter.top1")}}
        </div>
      </div>
      <div style="font-size: 12px; padding: .8rem 1rem 0;line-height:18px;color:#fff">
        {{$t("foorter.top2")}}
      </div>
    </div>
    <div
      style="width: 96%; background: url(/img/home/yixian.1c0cf0b3.png) no-repeat top / 100%; margin: 0 auto; overflow-x: hidden; padding: 0 .5rem 1rem; position: relative; overflow: hidden;"
    >
      <div
        style="margin-top: 7.66667rem; display: flex; justify-content: flex-start; align-items: center; position: relative; z-index: 9;font-size: 14px;"
        class="zhong"
      >
        <a :class="index1?'act':''" @click="toStatus(1)">{{$t("foorter.top4")}}</a>
        <a :class="index2?'act':''" @click="toStatus(2)">{{$t("foorter.top5")}}</a>
        <a :class="index3?'act':''" @click="toStatus(3)">{{$t("foorter.top6")}}</a>
      </div>
    </div>
    <div :style="index1?'display:block':'display:none'" style="margin-left: 1.5%;padding:5px 5px 20px 5px;width:97%;background: #fe6691;border-radius: 2px 2px .66667rem .66667rem;">
      <div>
        <div class="horizontalItem" v-for="item in datalist" :key="item.id" @click="toDetail(item.id)">
          <div class="imgBox">
            <div
              class="van-image"
              style="width: 120px; height: 180px; overflow: hidden; border-radius: 8px;"
            >
              <img :src="item.img_url" class="van-image__img" style="object-fit: cover;" />
            </div>
          </div>
          <div style="width: calc(100% - 140px);"><div style="width:100%;margin-top: 0px;height: 32px;line-height: 32px;font-size: 14px;color: #000"><div style="width: 60%;float:left;margin-left:2px;text-align: left;">
{{ item.xuanfei_name }}
</div>
<div  style="width: 38%;float:right;margin-right:2px;text-align: right;height: 32px;line-height: 32px">
	<img src="/img/home/dingwei.png" style="width:16px;height:16px;vertical-align: middle;">{{ item.class_name }}
</div>
<div style="clear:both"></div>
</div>
            <div class="top">
              <div>
                <div class="van-image" style="width: 62px;height: 28px">
                  <img src="/img/home/rz.71425b8f.png" style="width: 62px;height: 28px" class="van-image__img" />
                </div>
              </div>
              <div
                style="display:none;width: 70px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
              >
                {{ item.xuanfei_name }}
              </div>
            </div>
            <div class="tags" style="padding-top: 10px;">
              <van-tag
                v-for="(tag, index) in item.flagArray"
                :key="index"
                :type="tagTypes[index]"
              >
                {{ tag }}
              </van-tag>
            </div>
            <div style="display: flex; align-items: center;padding: 0px 0px 10px 0px;">
              <van-rate v-model="item.number" color="#ffd21e" size="20px" />
            </div>

            <div class="yueta">{{$t("index.about")}}</div>
          </div>
        </div>
      </div>
    </div>
    <div :style="index3?'display:block':'display:none'" style="background: linear-gradient(rgb(254, 89, 134), rgb(255, 132, 139)); width: 96%; margin: 0px auto 30px; border-radius:0 2px 2px 0px; overflow: hidden; padding-bottom: 10px;color: #fff;padding: 0 10px 10px 10px;">
		{{$t("foorter.top3")}}
	</div>
    <div :style="index2?'display:block':'display:none'"
      style="background: linear-gradient(rgb(254, 89, 134), rgb(255, 132, 139)); width: 96%; margin: 0px auto 30px; border-radius:0 2px 2px 0px; overflow: hidden; padding-bottom: 10px;"
    >
      <div style="color: rgb(255, 232, 105); text-align: center; padding: 10px 0px;">
        當前 1590 人在線匹配
      </div>
      <div class="OnlineMatching">
        <div
          :style="{
            transform: `translate(0px, ${translateY}px)`,
            transition: 'transform 1s ease-in',
          }"
          ref="scrollContainer"
        >
          <div style="overflow: hidden;">
            <ul class="item">
              <li>ちざきまきこ 約炮賬號入會成功</li>
              <li>しらつちのりこ 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
            </ul>
          </div>
          <div style="overflow: hidden;">
            <ul class="item">
              <li>ちざきまきこ 約炮賬號入會成功</li>
              <li>しらつちのりこ 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>はくやすのり 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>ちのなな 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>たけじかずのぶ 約炮賬號入會成功</li>
              <li>ふちれいこ 約炮賬號入會成功</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      translateY: -18,
      containerHeight: 0,
      hasToken: false,index1:true,index2:false,index3:false,
      basicData: [],
      datalist: [],
      groupedData: [],
      banners: [{}],
      bannerSwiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 800,
        autoplay: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      tagTypes: ['primary', 'success', 'danger', 'warning']
    };
  },
  methods: {
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        console.log(this.basicData);
        this.getNotice(this.basicData); //获取公告
        this.getBanner(this.basicData); //获取banner
        // this.getGameItem();//获取首页游戏列表
        // this.getMovieList_0(this.basicData);//获取首页视频0
        // this.getMovieList_1(this.basicData);//获取首页视频1
      });
    },
    getHotLottery() {
      this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
        console.log(res, 11)
      });
    },
    getBanner(data) {
      this.banners = data.banners;
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    getNotice(data) {
      this.notice = data.notice;
    },
    startAnimation() {
      const interval = setInterval(() => {
        this.translateY -= 18;
        if (this.translateY <= -this.containerHeight) {
          this.translateY = 0;
        }
      }, 1000);
      // 可选：在组件销毁时清除定时器
      this.$once("hook:beforeDestroy", () => {
        clearInterval(interval);
      });
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },toStatus(id) {
      if(id==1){this.index1=true;this.index2=false;this.index3=false;}if(id==2){this.index1=false;this.index2=true;this.index3=false;}if(id==3){this.index1=false;this.index2=false;this.index3=true;}},
    checkToken() {
      const token = localStorage.getItem("token");
      console.log(token);
      this.hasToken = !!token; // 如果 token 存在，则 hasToken 为 true，否则为 false
      console.log(this.hasToken);
      this.$nextTick(() => {
        console.log("View updated:", this.hasToken);
      });
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist1",
        data: { id: 0, page: 1 },
      }).then((res) => {
        const lanng = this.$t("auth.lang");
        console.log(lanng)
        this.datalist = res.data;
        this.datalist.forEach(item => {
          const parts = item.flag.split('|')
          lanng == 'zh' ? item.flag = parts[0] : lanng == 'en' ? item.flag = parts[1] : lanng == 'ja' ? item.flag = parts[2] : item.flag = parts[3]
          item.flagArray = item.flag.split('，');
        })
        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
        console.log(this.groupedData);
        console.log(res.data);
      });
    },
  },
  mounted() {
    this.containerHeight = this.$refs.scrollContainer.clientHeight;
    this.startAnimation();
  },
  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getHotLottery()
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 13vw;
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;
  .img {
    height: 80px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.banner_swiper {
  width: 100%;
  padding: 0 20px
}
.banner_img {
  border-radius: 30px;
}
.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 7vw;
}
.zhong a {
  color: #ea4d4d;
  background: #fff;
  padding: 12px 32px;
  margin-right: 12px;
  border-radius: 106px;
}
.zhong .act {
  background: linear-gradient(180deg, #fff2ef, #fadad7, #f7cac8);
}
.slide {
  overflow: hidden;
  border: 4PX solid #fff;
  border-radius: .6rem .6rem .66667rem .66667rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: 11.66667rem;
  background: #fff;
  margin-bottom: .66667rem;
}
.sub {
  background: rgb(63, 58, 91);
  padding: 8px;
  color: rgb(235, 202, 175);
  font-size: 24px;
  border-radius: 16px 0;
  margin-left: 4px;
}
.gdgride {
  padding-right: 40px;
}
.gdgride div {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}
.gdgride span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  font-size: 3vw;
  top: -11vw;
  right: -11vw;
}
.gdgride span i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
}
.van-image {
  position: relative;
  display: inline-block;
}
.horizontalItem {
  display: flex;
  background: #fff;;
  padding: 10px 10px;
  border-radius: 20px;
  margin-top: 20px;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}
.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}
.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.top {
  display: flex;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg,#fa6ba6,#f32879);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
.OnlineMatching {
  height: 28vw;
  overflow: hidden;
}
.OnlineMatching ul li {
  text-align: center;
  color: #fff;
  font-size: 4vw;
  margin-top: 20px;
}
::v-deep .van-image__loading {
  border-radius: 30px;
}
</style>
